// extracted by mini-css-extract-plugin
export default {"tooltipCard":"DynamicChipsTooltip_tooltipCard__hu6WG","tooltipList":"DynamicChipsTooltip_tooltipList__n+BDf"};